import React from 'react';
export const ChangePassword = React.lazy(() => import('./ChangePassword'));
